export enum InboxEntrySaveOrigin {
  NEW_TO_TOTAL = 'NEW_TO_TOTAL',
  ALREADY_COUNTED = 'ALREADY_COUNTED',
}
